import React from "react";
import PropTypes from "prop-types";
import I18n from "i18n-js";
import { isMobile } from "react-device-detect";
import { QRCodeSVG } from "qrcode.react";
import { Modal, Button, Typography } from "@duxton-web/ui";

import { getDownloadAppOneLink } from "../utils";

import "../assets/styles/download-app.less";
import grabMerchantAppQrLogo from "../assets/images/grab-merchant-app-qr-logo.svg";

const DownloadAppContent = ({ onCancel }) => {
  const downloadAppOneLink = getDownloadAppOneLink();
  return (
    <div className="download-app-modal qr-image">
      <Typography.Body style={{ fontSize: 20, fontWeight: 500 }}>
        {I18n.t("troyCommon-navigation-005-001")}
      </Typography.Body>
      <div className="download-your-app-qr">
        <QRCodeSVG
          size={160}
          value={downloadAppOneLink}
          imageSettings={{
            src: grabMerchantAppQrLogo,
            height: 48,
            width: 48,
            excavate: true,
          }}
        />
      </div>
      <Typography.Body level={2} type="secondary">
        {I18n.t("troyCommon-navigation-005-002")}
      </Typography.Body>
      <div style={{ marginTop: 32 }}>
        <Button onClick={onCancel} block type="secondary">
          {I18n.t("troyCommon-navigation-005-003")}
        </Button>
      </div>
    </div>
  );
};

const TroyDownloadAppModal = (props) => {
  const { visible, onCancel, maskClosable, title, body, iosURL, androidURL } =
    props;

  if (isMobile) {
    return (
      <div
        className="download-app-fullscreen"
        style={{ display: visible ? "block" : "none" }}
      >
        <DownloadAppContent
          {...{
            title,
            body,
            iosURL,
            androidURL,
            onCancel,
          }}
        />
      </div>
    );
  }

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      width={420}
      backdropClosable={maskClosable}
      footer={null}
    >
      <DownloadAppContent
        {...{
          title,
          body,
          iosURL,
          androidURL,
          onCancel,
        }}
      />
    </Modal>
  );
};

TroyDownloadAppModal.propTypes = {
  visible: PropTypes.bool,
  onCancel: PropTypes.func,
  maskClosable: PropTypes.bool,
  title: PropTypes.string,
  body: PropTypes.string,
  iosURL: PropTypes.string,
  androidURL: PropTypes.string,
};

TroyDownloadAppModal.defaultProps = {
  visible: false,
  onCancel: () => null,
  maskClosable: true,
  title: null,
  body: null,
  iosURL: null,
  androidURL: null,
};

export { TroyDownloadAppModal };
